// for inventory L2

export const inventoryL2Options = [
  {
    id: 'IB1',
    value: 'Receiving',
    text: 'Receiving',
    number: '(28)',
    Icon: 'sign in alternate',
    gradientvalue: 80,
  },
  {
    id: 'IB2',
    value: 'Delivery',
    text: 'Delivery',
    number: '(5)',
    Icon: 'shipping',
    gradientvalue: 20,
  },
  {
    id: 'IB3',
    value: 'Reports',
    text: 'Reports',
    number: '(7)',
    Icon: 'file alternate outline',
    gradientvalue: -10,
  },
];

//for inventory L3
export const recieveanddeliveryoptions = [
  {
    id: 'IRB1',
    value: 'Register',
    text: 'Register',
    Icon: 'registered',
    gradientvalue: 80,
  },
  {
    id: 'IRB2',
    value: 'Verify',
    text: 'Verify',
    Icon: 'check',
    gradientvalue: 20,
  },
  { id: 'IRB3', value: 'Tag', text: 'Tag', Icon: 'tag', gradientvalue: 90 },
  {
    id: 'IRB4',
    value: 'Create Order Receiving',
    text: 'Create Order',
    Icon: 'check square outline',
    gradientvalue: 90,
  },
];
export const receivingReportsOptions = [
  {
    id: 'IRR1',
    value: 'New Asset Added',
    number: '',
    text: 'New Asset Added',
    Icon: 'ticket',
    gradientvalue: 80,
  },
  {
    id: 'IRR2',
    value: 'Current Month Asset CAN Movement',
    number: '',
    text: 'Current Month Asset CAN Movement',
    Icon: 'chevron circle right',
    gradientvalue: 20,
  },
  {
    id: 'IRR3',
    value: 'Pending Returns From Borrowers',
    number: '',
    text: 'Pending Returns from Borrowers',
    Icon: 'wait',
    gradientvalue: 10,
  },
  {
    id: 'IRR4',
    value: 'Assets Cleaned',
    number: '',
    text: 'Assets Cleaned',
    Icon: 'calendar check outline',
    gradientvalue: 90,
  },
  {
    id: 'IRR5',
    value: 'Assets Scheduled For Cleaning',
    number: '',
    text: 'Assets Scheduled for Cleaning',
    Icon: 'calendar check outline',
    gradientvalue: 90,
  },
  {
    id: 'IRR6',
    value: 'Digitalization Priority',
    number: '',
    text: 'Digitalization Priority',
    Icon: 'ordered list',
    gradientvalue: 90,
  },
];
export const deliveryOptions = [
  {
    id: 'IDB1',
    value: 'Order Request',
    text: 'Order Request',
    Icon: 'sign-out',
    gradientvalue: 20,
  },
  {
    id: 'IDB2',
    value: 'Order Register',
    text: 'Order Register',
    Icon: 'registered outline',
    gradientvalue: 20,
  },
  {
    id: 'IDB3',
    value: 'Approve',
    text: 'Approve',
    Icon: 'check circle outline',
    gradientvalue: 20,
  },
  {
    id: 'IDB4',
    value: 'Assign Picker Delivery',
    text: 'Assign Picker',
    Icon: 'hand lizard outline',
    gradientvalue: 20,
  },
  {
    id: 'IDB5',
    value: 'Create Order',
    text: 'Create Order',
    Icon: 'chevron circle right',
    gradientvalue: 20,
  },
  {
    id: 'IDB6',
    value: 'Delivery',
    text: 'Delivery',
    Icon: 'clipboard check',
    gradientvalue: 20,
  },
];
